export const MAIN_ID = "main"
export const PAGE_TITLE_ID = "page-title"

const findPageStart = (): HTMLElement | null =>
  document.getElementById(PAGE_TITLE_ID) ??
  document.querySelector<HTMLElement>(`#${MAIN_ID} h1`) ??
  document.getElementById(MAIN_ID)

const isShown = (element: HTMLElement) => {
  if (typeof element.checkVisibility === "function") {
    return element.checkVisibility()
  }
  for (
    let current: HTMLElement | null = element;
    current;
    current = current.parentElement
  ) {
    if (getComputedStyle(current).display === "none") return false
  }
  return true
}

const staysInPageContent = (element: Element | null) =>
  element instanceof HTMLElement &&
  element.isConnected &&
  Boolean(element.closest(`#${MAIN_ID}`)) &&
  isShown(element)

export const findSelectedTabOrPageStart = (): HTMLElement | null =>
  document.querySelector<HTMLElement>(
    `#${MAIN_ID} [role="tab"][aria-selected="true"]`,
  ) ?? findPageStart()

export const focusPageStart = (
  options?: FocusOptions,
  findTarget: () => HTMLElement | null = findPageStart,
) => {
  const target = findTarget()
  if (!target) return

  if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1")
  target.focus(options)
}

export const focusPageStartWhenVisible = ({
  timeoutMs,
  findTarget = findPageStart,
  ...options
}: FocusOptions & {
  timeoutMs: number
  findTarget?: () => HTMLElement | null
}) =>
  new Promise<void>((resolve) => {
    const focusedAtStart = document.activeElement
    const deadline = performance.now() + timeoutMs

    const attempt = () => {
      const focusedNow = document.activeElement
      const userMovedFocus =
        focusedNow !== focusedAtStart && focusedNow !== document.body
      if (userMovedFocus) return resolve()
      if (staysInPageContent(focusedAtStart)) return resolve()

      const target = findTarget()
      if (target && isShown(target)) {
        focusPageStart(options, findTarget)
        return resolve()
      }
      if (performance.now() >= deadline) return resolve()
      requestAnimationFrame(attempt)
    }

    attempt()
  })
